import React, { useState } from "react";
import { LocalShipping } from '@mui/icons-material';
import { Card, CardContent, Chip, Divider, Grid, Paper, Typography } from "@mui/material";
import { Root } from "../../Const/componentStyles";
import CategoryIcon from '@mui/icons-material/Category';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ItemMaster from "./ItemMaster";
import UserMaster from "./UserMaster";
import { RootState } from "../../Redux/store/ReduxStore";
import { useSelector } from "react-redux";
import {
    MDBCard,
    MDBCardBody,
    MDBInput,
} from 'mdb-react-ui-kit';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BarCodeMaster from "./BarCodeMaster";
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

type ReportIconsType = {
  [key: string]: JSX.Element;
};

const ReportIcons: ReportIconsType = {
    "Item Master" : <CategoryIcon />,
    "User Master" : <ManageAccountsIcon />,
    "BarCode Master" : <QrCodeScannerIcon />
}

const MastersMain:React.FC = () => {
    const [showList,setShowList] = useState(false);
    const [selected,setSelected] = useState('');
    const user = useSelector((state:RootState)=>state.auth.user);

    const categories = [
        {
            groupName: 'Master Data',
            items: ["Item Master"
                ,"User Master",
                // "BarCode Master"
            ],
        },
    ];

    const handleSelect = (selected:string) => {
        setSelected(selected);
        setShowList(true);
    }
    
    const handleBack = () => {
        setShowList(false);
        setSelected('');
    }

    return(
        <div className="pt-3 position-relative">
            {!showList?
                <Grid container spacing={2}>
                    {categories.map((group, groupIndex) => (
                        <Grid item xs={12} key={groupIndex}>
                        <Root>
{/*                             <Typography variant="h5" component="div"> */}
{/*                                 <Divider textAlign="left" */}
{/*                                     sx={{ */}
{/*                                         "&::before, &::after": { */}
{/*                                             borderColor: "primary.main", */}
{/*                                         }, */}
{/*                                     }} */}
{/*                                 > */}
{/*                                     <Chip label={group.groupName} color='info' variant="outlined"/> */}
{/*                                 </Divider> */}
{/*                             </Typography> */}
                            <Typography variant="h5" component="div">
                                <Chip label={group.groupName} className="label-ui font-28 fw-bold mb-2 p-0 border-0" variant="outlined"/>
                            </Typography>
                            <MDBCard className="">
                                <MDBCardBody className="text-white p-3 p-md-5">
                                    <Grid container spacing={2} className={'fade-in'}>
                                        {group.items.map((category, categoryIndex) => (
                                            <Grid item xs={12} sm={6} md={4} lg={3} key={categoryIndex}>
                                                <Card
                                                    onClick={() => handleSelect(category)}
                                                >
                                                <CardContent className="shadow"
                                                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',cursor: 'pointer', }}
                                                >
                                                        <Typography className="text-center" variant="h6" component="div">
                                                            <span className="loading-icon text-theme">{ReportIcons[category]}</span>
                                                            <p className="m-0">{category}</p>
                                                        </Typography>
                                                </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </MDBCardBody>
                            </MDBCard>
                        </Root>
                    {/* </Paper> */}
                </Grid>
            ))}
            </Grid>
            :
                <div>
                    <div className="d-flex align-items-center justify-content-between">
                        <label className="label-ui font-28 fw-bold mb-3 p-0 border-0">Master Data</label>
                        <span className="mb-3">
                            <Chip
                                className="btn-outline-primary"
                                label="Masters List"
                                color='info'
                                onClick={handleBack}
                                variant="outlined"
                            />
                        </span>
                    </div>
                    {
                        selected === "Item Master" && <ItemMaster />
                    }
                    {
                        selected === "User Master" && <UserMaster />
                    }
                    {
                        selected === "BarCode Master" && <BarCodeMaster />
                    }
                </div>
            }
        </div>
    )
}

export default MastersMain;